<script>
import Pager from './pager.vue';
// import ElSelect from 'element-ui/lib/select';
import ElOption from 'element-ui/lib/option';
import ElInput from 'element-ui/lib/input';
import Locale from 'element-ui/lib/mixins/locale';
import { valueEquals } from 'element-ui/lib/utils/util';

export default {
  name: 'RtPagination',

  components: {
    Prev: {
      render (h) {
        return (
          <div class="rt-pagination-prev">
            {this.$parent.simple && (
              <button
                type="button"
                class="begin-button"
                disabled={
                  this.$parent.disabled || this.$parent.internalCurrentPage <= 1
                }
              >
                <rt-icon
                  name="rt-base-arrow-left-begin-lined"
                  size="12"
                  on-click={this.$parent.goToBegin}
                ></rt-icon>
              </button>
            )}
            <button
              type="button"
              class="btn-prev"
              disabled={
                this.$parent.disabled || this.$parent.internalCurrentPage <= 1
              }
              on-click={this.$parent.prev}
            >
              {this.$parent.prevText ? (
                <span>{this.$parent.prevText}</span>
              ) : (
                <rt-icon name="rt-base-arrow-left-lined" size="12"></rt-icon>
              )}
            </button>
          </div>
        );
      }
    },

    Next: {
      render (h) {
        return (
          <div class="rt-pagination-next">
            <button
              type="button"
              class="btn-next"
              disabled={
                this.$parent.disabled ||
                this.$parent.internalCurrentPage ===
                  this.$parent.internalPageCount ||
                this.$parent.internalPageCount === 0
              }
              on-click={this.$parent.next}
            >
              {this.$parent.nextText ? (
                <span>{this.$parent.nextText}</span>
              ) : (
                <rt-icon name="rt-base-arrow-right-lined" size="12"></rt-icon>
              )}
            </button>
            {this.$parent.simple && (
              <button
                type="button"
                class="end-button"
                disabled={
                  this.$parent.disabled ||
                  this.$parent.internalCurrentPage ===
                    this.$parent.internalPageCount ||
                  this.$parent.internalPageCount === 0
                }
              >
                <rt-icon
                  name="rt-base-arrow-right-end-lined"
                  size="12"
                  on-click={this.$parent.goToEnd}
                ></rt-icon>
              </button>
            )}
          </div>
        );
      }
    },

    Sizes: {
      mixins: [Locale],

      /**
       * bug-#29804
       * http://rtzentao3.recloud.com.cn/zentao/bug-view-29804.html
       * 向下注册elFormItem，解决表格中的elInput受到上层form的影响
       */
      provide () {
        return {
          elFormItem: {}
        };
      },

      props: {
        pageSizes: Array
      },

      watch: {
        pageSizes: {
          immediate: true,
          handler (newVal, oldVal) {
            if (valueEquals(newVal, oldVal)) return;
            if (Array.isArray(newVal)) {
              this.$parent.internalPageSize =
                newVal.indexOf(this.$parent.pageSize) > -1
                  ? this.$parent.pageSize
                  : this.pageSizes[0];
            }
          }
        }
      },

      render (h) {
        return (
          <span class="rt-xpc-pagination__sizes el-pagination__sizes">
            <el-select
              value={this.$parent.internalPageSize}
              popperClass={this.$parent.popperClass || ''}
              size="mini"
              on-input={this.handleChange}
              disabled={this.$parent.disabled}
            >
              {this.pageSizes.map(item => (
                <el-option
                  value={item}
                  label={item + this.t('el.pagination.pagesize')}
                ></el-option>
              ))}
            </el-select>
          </span>
        );
      },

      components: {
        ElOption
      },

      methods: {
        handleChange (val) {
          if (val !== this.$parent.internalPageSize) {
            this.$parent.internalPageSize = val = parseInt(val, 10);
            this.$parent.userChangePageSize = true;
            this.$parent.$emit('update:pageSize', val);
            this.$parent.$emit('size-change', val);

            this.$parent.getContainer(this.$parent.isTableClick);
          }
        }
      }
    },

    Jumper: {
      mixins: [Locale],

      components: { ElInput },

      data () {
        return {
          userInput: null
        };
      },

      watch: {
        '$parent.internalCurrentPage' () {
          this.userInput = null;
        }
      },

      methods: {
        handleKeyup ({ keyCode, target }) {
          // Chrome, Safari, Firefox triggers change event on Enter
          // Hack for IE: https://github.com/ElemeFE/element/issues/11710
          // Drop this method when we no longer supports IE
          if (keyCode === 13) {
            this.handleChange(target.value);
          }
        },
        handleInput (value) {
          this.userInput = value;
        },
        handleChange (value) {
          this.$parent.internalCurrentPage = this.$parent.getValidCurrentPage(
            value
          );
          this.$parent.emitChange();
          this.userInput = null;
        }
      },

      render (h) {
        return (
          <span class="rt-xpc-pagination__jump el-pagination__jump">
            {this.t('el.pagination.goto')}
            <el-input
              class="el-pagination__editor is-in-pagination"
              min={1}
              max={this.$parent.internalPageCount}
              value={
                this.userInput !== null
                  ? this.userInput
                  : this.$parent.internalCurrentPage
              }
              type="number"
              disabled={this.$parent.disabled}
              nativeOnKeyup={this.handleKeyup}
              onInput={this.handleInput}
              onChange={this.handleChange}
            />
            {this.t('el.pagination.pageClassifier')}
          </span>
        );
      }
    },

    Total: {
      mixins: [Locale],

      render (h) {
        return typeof this.$parent.total === 'number' ? (
          <span class="rt-xpc-pagination-total el-pagination__total">
            {`${this.t('el.pagination.total', {
              total: this.$parent.total
            })} ${this.$tx('记录', 'xpc.common.record')}`}
          </span>
        ) : (
          ''
        );
      }
    },

    Pager
  },

  props: {
    // 每页显示条目个数
    pageSize: {
      type: Number,
      default: 20
    },
    small: Boolean,
    // 总条目数
    total: Number,
    // 总页数
    pageCount: Number,
    // 页码按钮数量，当总页数超出该值会折叠
    pagerCount: {
      type: Number,
      validator (value) {
        return (
          (value | 0) === value && value > 4 && value < 22 && value % 2 === 1
        );
      },
      default: 7
    },
    // 当前页数
    currentPage: {
      type: Number,
      default: 1
    },
    // 组件布局，可选值 sizes, prev, pager, next, jumper, ->, total, slot
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    // 每页显示个数
    pageSizes: {
      type: Array,
      default () {
        return [5, 10, 20, 30, 40, 50];
      }
    },
    // 每页显示个数选择器的下拉框类名
    popperClass: String,
    // 代替图标显示的上一页文字
    prevText: String,
    // 代替图标显示的下一页文字
    nextText: String,
    // 是否显示背景色
    background: Boolean,
    // 是否只读
    disabled: Boolean,
    // 只有一页时是否隐藏
    hideOnSinglePage: Boolean,
    // 是否为单独分页点击
    isTableClick: Boolean,
    /**
     * @public 简约模式
     */
    simple: {
      type: Boolean,
      default: false
    }
  },

  inject: {
    xpcPaginationContainer: {
      default: null
    }
  },

  data () {
    return {
      internalCurrentPage: 1, // pageIndex
      internalPageSize: 0, // pageSize
      lastEmittedPage: -1,
      userChangePageSize: false
    };
  },

  computed: {
    internalPageCount () {
      if (typeof this.total === 'number') {
        return Math.max(1, Math.ceil(this.total / this.internalPageSize));
      } else if (typeof this.pageCount === 'number') {
        return Math.max(1, this.pageCount);
      }
      return null;
    }
  },

  watch: {
    currentPage: {
      immediate: true,
      handler (val) {
        this.internalCurrentPage = this.getValidCurrentPage(val);
      }
    },

    pageSize: {
      immediate: true,
      handler (val) {
        this.internalPageSize = isNaN(val) ? 10 : val;
      }
    },

    internalCurrentPage: {
      immediate: true,
      handler (newVal) {
        this.$emit('update:currentPage', newVal);
        this.lastEmittedPage = -1;
      }
    },

    internalPageCount (newVal) {
      /* istanbul ignore if */
      const oldPage = this.internalCurrentPage;
      if (newVal > 0 && oldPage === 0) {
        this.internalCurrentPage = 1;
      } else if (oldPage > newVal) {
        this.internalCurrentPage = newVal === 0 ? 1 : newVal;
        this.userChangePageSize && this.emitChange();
      }
      this.userChangePageSize = false;
    }
  },

  methods: {
    getParams () {
      return {
        pageSize: this.internalPageSize,
        pageIndex: this.internalCurrentPage
      };
    },
    getContainer (val) {
      // 分页调用 fetchData 方法
      if (
        this.xpcPaginationContainer &&
        this.xpcPaginationContainer.fetchData
      ) {
        this.xpcPaginationContainer.fetchData(val);
      }
    },
    handleCurrentChange (val) {
      this.internalCurrentPage = this.getValidCurrentPage(val);
      this.userChangePageSize = true;

      this.emitChange();
    },

    prev () {
      if (this.disabled) return;
      const newVal = this.internalCurrentPage - 1;
      this.internalCurrentPage = this.getValidCurrentPage(newVal);
      this.$emit('prev-click', this.internalCurrentPage);
      this.emitChange();
    },

    next () {
      if (this.disabled) return;
      const newVal = this.internalCurrentPage + 1;
      this.internalCurrentPage = this.getValidCurrentPage(newVal);
      this.$emit('next-click', this.internalCurrentPage);
      this.emitChange();
    },
    /**
     * @private 去第一页
     */
    goToBegin () {
      this.internalCurrentPage = 1;
      this.$emit('next-click', this.internalCurrentPage);
      this.emitChange();
    },
    /**
     * @private 去最后一页
     */
    goToEnd () {
      this.internalCurrentPage = this.internalPageCount;
      this.$emit('next-click', this.internalCurrentPage);
      this.emitChange();
    },
    getValidCurrentPage (value) {
      value = parseInt(value, 10);

      const havePageCount = typeof this.internalPageCount === 'number';

      let resetValue;
      if (!havePageCount) {
        if (isNaN(value) || value < 1) resetValue = 1;
      } else {
        if (value < 1) {
          resetValue = 1;
        } else if (value > this.internalPageCount) {
          resetValue = this.internalPageCount;
        }
      }

      if ((resetValue === undefined && isNaN(value)) || resetValue === 0) {
        resetValue = 1;
      }

      return resetValue === undefined ? value : resetValue;
    },

    emitChange () {
      this.$nextTick(() => {
        if (
          this.internalCurrentPage !== this.lastEmittedPage ||
          this.userChangePageSize
        ) {
          this.$emit('current-change', this.internalCurrentPage);

          this.lastEmittedPage = this.internalCurrentPage;
          this.userChangePageSize = false;
          this.getContainer(this.isTableClick);
        }
      });
    }
  },

  render (h) {
    const layout = this.layout;
    if (!layout) return null;
    if (
      this.hideOnSinglePage &&
      (!this.internalPageCount || this.internalPageCount === 1)
    ) {
      return null;
    }

    let template = (
      <div
        class={[
          'rt-xpc-pagination el-pagination',
          {
            'is-background': this.background,
            'rt-xpc-pagination--small el-pagination--small':
              this.small || this.simple,
            'simple-mode': this.simple
          }
        ]}
      ></div>
    );
    const TEMPLATE_MAP = {
      prev: <prev></prev>,
      jumper: <jumper></jumper>,
      pager: (
        <pager
          size={this.small}
          currentPage={this.internalCurrentPage}
          pageCount={this.internalPageCount}
          pagerCount={this.pagerCount}
          on-change={this.handleCurrentChange}
          disabled={this.disabled}
          simple={this.simple}
        ></pager>
      ),
      next: <next></next>,
      sizes: <sizes pageSizes={this.pageSizes}></sizes>,
      slot: <slot>{this.$slots.default ? this.$slots.default : ''}</slot>,
      total: <total></total>
    };
    const components = layout.split(',').map(item => item.trim());
    const rightWrapper = <div class="el-pagination__rightwrapper"></div>;
    let haveRightWrapper = false;

    template.children = template.children || [];
    rightWrapper.children = rightWrapper.children || [];
    components.forEach(compo => {
      if (compo === '->') {
        haveRightWrapper = true;
        return;
      }

      if (!haveRightWrapper) {
        template.children.push(TEMPLATE_MAP[compo]);
      } else {
        rightWrapper.children.push(TEMPLATE_MAP[compo]);
      }
    });

    if (haveRightWrapper) {
      template.children.unshift(rightWrapper);
    }
    return template;
  }
};
</script>



// WEBPACK FOOTER //
// rtPagination.vue?75d7608f